<template>
  <mdb-card>
    <mdb-card-header class="pt-4 indigo">
      <mdb-card-title class="text-white"
        ><strong>{{
          $t("import_benefit_codes_header")
        }}</strong></mdb-card-title
      >
    </mdb-card-header>
    <mdb-card-body>
      <mdb-row>
        <mdb-col md="12">
          <mdb-file-input
            sm
            @getValue="getFileInputValue"
            floating
            icon="paperclip"
            gradient="blue"
          />
        </mdb-col>
        <mdb-col md="6">
          <AdvertisementBenefitSelection v-on:advertbenefits="getIds"/>
        </mdb-col>
        <mdb-col md="6">
          <mdb-input
            v-model="name"
            type="text"
            :label="$t('import_benefit_codes_name')"
            icon="pen"
            :rows="2"
          />
        </mdb-col>
        <mdb-col md="6">
          <mdb-btn
            v-on:click="importBenefitCodes"
            color="indigo"
            class="white-text"
            icon="paper-plane"
            >{{ $t("load") }}</mdb-btn
          >
        </mdb-col>
      </mdb-row>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
  mdbFileInput,
  mdbInputMask,
} from "mdbvue";

import AdvertisementBenefitSelection from "@/components/AdvertisementBenefitSelection.vue";

export default {
  name: "ImportBenefitCodes",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    mdbFileInput,
    AdvertisementBenefitSelection
  },
  directives: {
    mdbInputMask,
  },
  data() {
    return {
      name: "",
      advertisementId: 0,
      benefitId: 0,
      postData: {},
      importedProductCodes: [],
      importBenefitCodespath: "/1.0/front/benefitcodes/import",
    };
  },
  methods: {
    getFileInputValue(val) {
    if (!val || val.length === 0) return;
    this.rawFile = val[0]; // File object — used in FormData
    },
    checkInputs() {
      if (this.name !== "" && this.benefit_id !== 0) return true;
      else return false;
    },
    getIds(advertisementId, benefitId){
      this.advertisementId = advertisementId;
      this.benefitId = benefitId;
    },
    importBenefitCodes() {
      if (!this.checkInputs()) {
        this.$notify.error({
          message: this.$t("import_benefit_codes_check_input"),
          position: "top right",
          timeOut: this.$store.state.notifytimeoutshort,
        });
        return;
      }
      const formData = new FormData();
      formData.append("file", this.rawFile); // store val[0] as this.rawFile
      formData.append("benefit_id", this.benefitId);
      formData.append("name", this.name);
      formData.append("sessionid", this.$store.getters.getToken);
      this.$http
        .post(this.importBenefitCodespath, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("import_benefit_codes_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("import_benefit_codes_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
